import React from 'react';
import { MinusIcon, PlusIcon } from './Icons';

interface MinusPlusProps {
	value: number;
	onChange: (value: number) => void;
	min?: number;
	max?: number;
	label?: string;
}

export const MinusPlus = ({ value, onChange, min = 1, max = 20, label }: MinusPlusProps) => {
	const stepper = (
		<div className="booking-bar__stepper">
			<button
				type="button"
				className="booking-bar__stepper-btn"
				onClick={() => value > min && onChange(value - 1)}
				disabled={value <= min}
			>
				<MinusIcon />
			</button>
			<span className="booking-bar__stepper-count">{value}</span>
			<button
				type="button"
				className="booking-bar__stepper-btn"
				onClick={() => value < max && onChange(value + 1)}
				disabled={value >= max}
			>
				<PlusIcon />
			</button>
		</div>
	);

	if (!label) {
		return stepper;
	}

	return (
		<div className="booking-bar__stepper-row">
			<span className="booking-bar__stepper-label">{label}</span>
			{stepper}
		</div>
	);
};
